// eslint-disable-next-line import/no-extraneous-dependencies
import Express from 'express';
import {isError} from '@epic-mw/error-types';

export function respondJson(res: Express.Response, response: {[key: string]: any}): void {
    try {
        res.setHeader('Content-Type', 'application/json');
    } catch (e) {
        console.error(
            'Failed to set Content-Type header. Request may have been redirected.',
            isError(e) && e.message
        );
    }

    try {
        res.send(JSON.stringify(response));
    } catch (e) {
        console.error('Failed to send response as json.', isError(e) && e.message);
    }
}
